import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "pr-2 py-1 text-sm"
};
const _hoisted_2 = {
  class: "font-weight-bold mr-1"
};
const _hoisted_3 = {
  class: "py-1 text-sm"
};
const _hoisted_4 = {
  class: "font-weight-bold mr-1"
};
import { onMounted, nextTick, watch, ref } from 'vue';
import { useCodeStore } from '@/services/useCodeStore';
import { useCompanyStore } from '@/services/UserService/useCompanyStore';
import { storeToRefs } from 'pinia';
export default {
  __name: 'CodePicker',
  props: {
    form: {
      type: Object,
      required: false
    },
    horizontal: {
      type: Boolean,
      required: false,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    activityRules: {
      type: Array,
      default: () => []
    },
    taskRules: {
      type: Array,
      default: () => []
    },
    hideDetails: {
      type: Boolean,
      default: true
    },
    activityRequired: {
      type: Boolean,
      default: false
    },
    taskRequired: {
      type: Boolean,
      default: false
    },
    okToClearDescription: {
      type: Boolean,
      default: false
    }
  },
  emits: ['codeChange'],
  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    const {
      companySettings
    } = storeToRefs(useCompanyStore());
    const companyStore = useCompanyStore();
    const codeStore = useCodeStore();
    const {
      activityList,
      taskList
    } = storeToRefs(codeStore);
    const loading = ref(false);
    const activityRef = ref(null);
    const taskRef = ref(null);
    const props = __props;
    onMounted(async () => {
      try {
        loading.value = true;
        await Promise.all([codeStore.activityCodes(), codeStore.taskCodes(), companyStore.loadMyCompany()]);
        populateCodes();
      } catch (error) {
        console.error(error);
      } finally {
        loading.value = false;
      }
    });
    const populateCodes = () => {
      if (!props.form.codes) {
        props.form.codes = {};
      } else {
        if (props.form.codes.activity?.id) {
          props.form.codes.activity = activityList.value.find(a => a.id === props.form.codes.activity?.id) || null;
        } else {
          props.form.codes.activity = null;
        }
        if (props.form.codes.task?.id) {
          props.form.codes.task = taskList.value.find(t => t.id === props.form.codes.task?.id) || null;
        } else {
          props.form.codes.task = null;
        }
      }
    };
    const checkDescription = (activity, task) => {
      emit('codeChange', props.form.codes);
      nextTick(() => {
        const codesSettings = companySettings.value.codes || {};
        let description = '';
        if (codesSettings.populateDescriptionsPlus) {
          // For populateDescriptionsPlus: always check both codes and combine them
          let activityDesc = '';
          let taskDesc = '';

          // Check if activity is present and valid
          if (props.form.codes?.activity?.id) {
            const foundActivity = activityList.value.find(a => a.id === props.form.codes?.activity?.id);
            if (foundActivity) {
              activityDesc = foundActivity.label;
            }
          }

          // Check if task is present and valid
          if (props.form.codes?.task?.id) {
            const foundTask = taskList.value.find(t => t.id === props.form.codes?.task?.id);
            if (foundTask) {
              taskDesc = foundTask.label;
            }
          }
          if (activityDesc && taskDesc) {
            description = `${activityDesc}, ${taskDesc}`;
          } else if (activityDesc) {
            description = activityDesc;
          } else if (taskDesc) {
            description = taskDesc;
          }
        } else {
          // For populateDescriptions only: use the most recently selected code
          if (activity && props.form.codes?.activity?.id) {
            const foundActivity = activityList.value.find(a => a.id === props.form.codes?.activity?.id);
            if (foundActivity) {
              description = foundActivity.label;
            }
          }
          if (task && props.form.codes?.task?.id) {
            const foundTask = taskList.value.find(t => t.id === props.form.codes?.task?.id);
            if (foundTask) {
              description = foundTask.label;
            }
          }
        }

        // Update the form description if needed
        if (codesSettings.populateDescriptions && (!props.form.description || props.okToClearDescription)) {
          props.form.description = description;
        }
      });
    };
    watch(() => props.form.codes, async () => {
      populateCodes();
    });
    return (_ctx, _cache) => {
      const _component_v_autocomplete = _resolveComponent("v-autocomplete");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["flex justify-between remove-all-input-styling tw", __props.horizontal ? 'flex-col' : 'flex-row'])
      }, [_createElementVNode("div", {
        class: _normalizeClass(["w-full", __props.horizontal ? '' : 'pr-2'])
      }, [_createElementVNode("label", _hoisted_1, [_cache[4] || (_cache[4] = _createTextVNode("Activity Code ", -1)), _withDirectives(_createElementVNode("span", _hoisted_2, "*", 512), [[_vShow, __props.activityRequired]])]), _createVNode(_component_v_autocomplete, {
        ref_key: "activityRef",
        ref: activityRef,
        modelValue: __props.form.codes.activity,
        "onUpdate:modelValue": [_cache[0] || (_cache[0] = $event => __props.form.codes.activity = $event), _cache[1] || (_cache[1] = $event => checkDescription(true, false))],
        items: _unref(activityList),
        loading: loading.value,
        "item-title": "label",
        "item-value": "id",
        "return-object": "",
        clearable: "",
        density: "compact",
        variant: "outlined",
        class: "remove-outline",
        placeholder: "Select Activity Code",
        "hide-details": __props.hideDetails,
        rules: __props.activityRules,
        "item-props": item => ({
          disabled: item.disabled
        }),
        "menu-props": {
          maxWidth: activityRef.value?.$el?.offsetWidth
        },
        disabled: __props.disabled,
        "data-cy": "activity-code-select"
      }, null, 8, ["modelValue", "items", "loading", "hide-details", "rules", "item-props", "menu-props", "disabled"])], 2), _createElementVNode("div", {
        class: _normalizeClass(["w-full", __props.horizontal ? 'pt-2' : 'pl-2'])
      }, [_createElementVNode("label", _hoisted_3, [_cache[5] || (_cache[5] = _createTextVNode("Task Code ", -1)), _withDirectives(_createElementVNode("span", _hoisted_4, "*", 512), [[_vShow, __props.taskRequired]])]), _createVNode(_component_v_autocomplete, {
        ref_key: "taskRef",
        ref: taskRef,
        modelValue: __props.form.codes.task,
        "onUpdate:modelValue": [_cache[2] || (_cache[2] = $event => __props.form.codes.task = $event), _cache[3] || (_cache[3] = $event => checkDescription(false, true))],
        items: _unref(taskList),
        loading: loading.value,
        "item-title": "label",
        "item-value": "id",
        density: "compact",
        "return-object": "",
        clearable: "",
        variant: "outlined",
        class: "remove-outline",
        placeholder: "Select Task Code",
        "hide-details": __props.hideDetails,
        rules: __props.taskRules,
        "item-props": item => ({
          disabled: item.disabled
        }),
        "menu-props": {
          maxWidth: taskRef.value?.$el?.offsetWidth
        },
        disabled: __props.disabled,
        "data-cy": "task-code-select"
      }, null, 8, ["modelValue", "items", "loading", "hide-details", "rules", "item-props", "menu-props", "disabled"])], 2)], 2);
    };
  }
};